import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormGroupDeleteService } from '../../services';

export const fetchFormGroupDelete = createAsyncThunk(
    'formGroupDelete/fetchFormGroupDelete',
    async ({ id }) => {
        const response = await FormGroupDeleteService(id)
        return response.result
    }
)

const formGroupDeleteSlice = createSlice({
    name: 'formGroupDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormGroupDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormGroupDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormGroupDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formGroupDeleteSlice.reducer;
